// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"88":"5745a9e8","208":"bb210eb5","488":"224a06ee","530":"3e3a2465","549":"81c63d5e","982":"9eac280c"}[chunkId] + ".css";
};